/**
 * Roles que el super_admin puede asignar en Editar/Crear usuario.
 * Alias históricos siguen vivos en BD/permisos; no se ofrecen en el picker
 * salvo que el usuario editado ya los tenga (para no romper la fila).
 */
export const CANONICAL_ASSIGNABLE_ROLES = [
  { value: 'usuario_final', label: 'Usuario final' },
  { value: 'usuario_final_sede', label: 'Usuario final sede' },
  { value: 'entrenador_d28d', label: 'Entrenador host D28D' },
  { value: 'entrenador_gym', label: 'Entrenador host gym' },
  { value: 'admin_d28d', label: 'Admin D28D' },
  { value: 'admin_gym_virtual', label: 'Admin gym virtual' },
  { value: 'admin_sede', label: 'Admin sede' },
  { value: 'admin_marca', label: 'Admin marca (holding)' },
  { value: 'super_admin', label: 'Super administrador' },
  { value: 'admin_food_plan', label: 'Admin plan alimentación' },
  { value: 'admin_training', label: 'Admin entrenadores' },
  { value: 'entrenador', label: 'Entrenador (coach)' },
  { value: 'nutricionista', label: 'Nutricionista' },
];

const CANONICAL_CODES = new Set(CANONICAL_ASSIGNABLE_ROLES.map((r) => r.value));

export function filterAssignableRoles(options, currentRoleCodes = []) {
  const current = new Set(
    (Array.isArray(currentRoleCodes) ? currentRoleCodes : [currentRoleCodes]).filter(Boolean),
  );
  const seen = new Set();
  const out = [];
  for (const opt of options || []) {
    const code = opt?.value || opt?.code;
    if (!code || seen.has(code)) continue;
    if (!CANONICAL_CODES.has(code) && !current.has(code)) continue;
    seen.add(code);
    out.push({
      value: code,
      label: opt.label || opt.name || code,
    });
  }
  for (const canon of CANONICAL_ASSIGNABLE_ROLES) {
    if (seen.has(canon.value)) continue;
    out.push(canon);
    seen.add(canon.value);
  }
  return out;
}
